<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <v-card
      class="mx-auto pb-5"
      max-width="350"
      :elevation="hover ? 16 : 2"
    >
      <v-img
        class="white--text align-end"
        height="300px"
        :src="legalNew.img"
      >
        <!-- <v-expand-transition>
          <div
              v-if="hover"
              class="text-center transition-fast-in-fast-out grey darken-2 v-card--reveal white--text"
              style="height: 300px; opacity: 0.5; font-size: 32px; line-height: 300px;"
          >
              More Info
          </div>
        </v-expand-transition> -->
      </v-img>
      <v-card-title>
        {{ legalNew.name }}
      </v-card-title>
      <v-card-subtitle class="pb-0">
        {{ legalNew.date }}
      </v-card-subtitle>
      <v-fade-transition>
        <v-overlay
          v-if="hover"
          absolute
          color="grey"
        >
          <v-btn @click="dialog = true">
            See more info
          </v-btn>
        </v-overlay>
      </v-fade-transition>
    </v-card>
  </v-hover>
</template>

<script>
  export default {
    props: ['legalNew']
  }
</script>
